import { render, staticRenderFns } from "./articlePannel.vue?vue&type=template&id=0a149428"
import script from "./articlePannel.vue?vue&type=script&lang=js"
export * from "./articlePannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports